const locale = {
    placeholder: 'Escolla hora',
};
export default locale;
